import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import bannerBg from "images/section-bg-search-slide1.jpg";
import bannerBg1 from "images/section-bg-search-slide2.jpg";
import bannerBg2 from "images/section-bg-search-slide3.jpg";
import theWire from "images/thewire-logo.png";
import SearchInputHomePage from "components/shared/SearchInput/SearchInput";
import { HeroContainer, HeroBackground } from "./styles/Hero.style";
import { Chip } from "@material-ui/core";
import { push } from "connected-react-router";
import { useDispatch } from "react-redux";
import Pilar from "./Pilar";
import entertainmentGif from "images/homepage-gifs/entertainmentGif.gif";
import brandGif from "images/homepage-gifs/brandGif.gif";
import researchGif from "images/homepage-gifs/researchGif.gif";
import editorialGif from "images/homepage-gifs/editorialGif.gif";

export function Hero(props) {
  const { heroTitle, showEasyCheckout } = props;

  const [state, setState] = useState({
    backgroundImage: bannerBg,
    searchInputValue: "",
    formError: false
  });

  React.useEffect(() => {
    const images = [bannerBg, bannerBg1, bannerBg2];
    setState((prev) => ({
      ...prev,
      backgroundImage: images[Math.floor(Math.random() * images.length)]
    }));
  }, []);

  const dispatch = useDispatch();

  const onClickCategory = (category) =>
    dispatch(push(`/licensing/search?q=&page=1&category=${category}`));

  return (
    <div style={{ background: "black" }}>
      <HeroBackground>
        <HeroContainer backgroundImage={state.backgroundImage}>
          <div className="layer" />
          <div className="callout">
            {props.wire ? (
              <img className="wireLogo" src={theWire} alt="THE WIRE" />
            ) : (
              <>
                <h1 className="hero-title-desktop">
                  Authentic <span className="title-highlight">Videos,</span> Extraordinary{" "}
                  <span className="title-highlight">Performance</span>
                </h1>
                <div className="hero-title-mobile-container">
                  <h1 className="hero-title-mobile">
                    Authentic <span className="title-highlight">Videos,</span>
                  </h1>
                  <h1 className="hero-title-mobile">Extraordinary</h1>
                  <h1 className="hero-title-mobile">
                    <span className="title-highlight">Performance</span>
                  </h1>
                </div>
              </>
            )}
            <SearchInputHomePage homepage />
            <div className="popular-categories">
              <h5>Popular Categories</h5>
              <div className="popular-categories-container">
                <Chip label={"Fails"} key={"Fails"} onClick={() => onClickCategory("Fails")} />
                <Chip label={"Humor"} key={"Humor"} onClick={() => onClickCategory("Humor")} />
                <Chip label={"Pets"} key={"Pets"} onClick={() => onClickCategory("Pets")} />
                <Chip
                  label={"Uplifting"}
                  key={"Uplifting"}
                  onClick={() => onClickCategory("Uplifting")}
                />
                <Chip label={"Family"} key={"Family"} onClick={() => onClickCategory("Family")} />
              </div>
            </div>
          </div>

          {!showEasyCheckout && props.children && <>{props.children}</>}
        </HeroContainer>

        <div className="pilar-container">
          <div className="pilar-row">
            <Pilar
              image={entertainmentGif}
              title={`Entertainment\n& Production`}
              description="Unlock the next level of creativity by accessing a vast library of pre-cleared UGC video, tailored for your projects in TV, film, gaming and more."
              link="https://view.ceros.com/trusted-media-brands/jukin-media-entertainment-and-production/p/1"
              pilarText="Explore Our Collection"
            />
            <Pilar
              image={brandGif}
              title={`Brands\n& Agencies`}
              description="Raw, relatable and authentic video content, cleared for commercial use in your advertising campaigns and marketing strategies."
              link="https://view.ceros.com/trusted-media-brands/jukin-media-brands-and-agencies/p/1"
              pilarText="Explore Our Collection"
            />

            <Pilar
              image={researchGif}
              title={`Custom Research\n& Clearance`}
              description="Our white-glove service connects you with expert researchers who’ll go beyond our library to source the perfect footage—and work to secure the rights and clearances so you’re ready to publish."
              link="https://view.ceros.com/trusted-media-brands/jukin-media-custom-research-and-clearance/p/1"
              pilarText="Explore Custom Solutions"
            />

            <Pilar
              image={editorialGif}
              title={`Self Service\n Editorial Licensing`}
              description="Access and publish pre-cleared UGC video clips instantly with Jukin’s self-serve editorial solution. Perfect for social, YouTube, blogs, and websites—bring real moments into your storytelling, faster than ever."
              reference="/licensing/pricing"
              pilarText="Explore Our Collection"
            />
          </div>
        </div>

        <div className="pilar-container-tablet">
          <div className="pilar-row pilar-row-tablet">
            <div className="pilar-wrapper-tablet">
              <Pilar
                image={entertainmentGif}
                title={`Entertainment\n& Production`}
                description="Unlock the next level of creativity by accessing a vast library of pre-cleared UGC video, tailored for your projects in TV, film, gaming and more."
                link="https://view.ceros.com/trusted-media-brands/jukin-media-entertainment-and-production/p/1"
                pilarText="Explore Our Collection"
              />
              <Pilar
                image={brandGif}
                title={`Brands\n& Agencies`}
                description="Raw, relatable and authentic video content, cleared for commercial use in your advertising campaigns and marketing strategies."
                link="https://view.ceros.com/trusted-media-brands/jukin-media-brands-and-agencies/p/1"
                pilarText="Explore Our Collection"
              />
            </div>

            <div>
              <Pilar
                image={researchGif}
                title={`Custom Research\n& Clearance`}
                description="Our white-glove service connects you with expert researchers who’ll go beyond our library to source the perfect footage—and work to secure the rights and clearances so you’re ready to publish."
                link="https://view.ceros.com/trusted-media-brands/jukin-media-custom-research-and-clearance/p/1"
                pilarText="Explore Custom Solutions"
              />

              <Pilar
                image={editorialGif}
                title={`Self Service\n Editorial Licensing`}
                description="Access and publish pre-cleared UGC video clips instantly with Jukin’s self-serve editorial solution. Perfect for social, YouTube, blogs, and websites—bring real moments into your storytelling, faster than ever."
                reference="/licensing/pricing"
                pilarText="Explore Our Collection"
              />
            </div>
          </div>
        </div>
      </HeroBackground>
    </div>
  );
}

Hero.propTypes = {
  clearAllSearch: PropTypes.func.isRequired,
  history: PropTypes.shape().isRequired,
  showEasyCheckout: PropTypes.bool
};

Hero.defaultProps = {
  showEasyCheckout: true
};

export default withRouter(Hero);
